export default __webpack_public_path__ + "static/HomepageHeroBackground-20be6dcf373a956f2787cd75d3c2a881.webp";